import { FC, useContext } from "react";

import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Paragraph } from "capitalrx-components-2.0/lib/typography";

import { ThemeSelectorContext } from "@/context";
import judiHealth from "@/static/logos/judi-health-horizontal-gradient.png";

import styles from "./Footer.module.scss";
import { Link } from "react-router";

export const Footer: FC = () => {
  const { clientDisplayName } = useContext(ThemeSelectorContext);
  const showFooter = clientDisplayName === "Judi Health";

  return (
    <>
      {showFooter && (
        <Stack alignment="center" className={styles.FooterContainer}>
          <Shelf spacing="small" style={{ alignItems: "center" }}>
            <img src={judiHealth} style={{ height: "24px", width: "282px" }} />
          </Shelf>
          <Paragraph textAlign = "center">
            <Body textAlign = "center">
              For help, contact{" "}
              <Link to = "mailto:hcphelp@judihealth.com">
                hcphelp@judihealth.com
              </Link>
              .{" "}
              <span style = {{ whiteSpace: "nowrap", display: "inline-block" }}>
                ® 2026 Judi Rx, Inc. All Rights Reserved.
              </span>
            </Body>
          </Paragraph>
        </Stack>
      )}
    </>
  );
};
